import type React from "react";
import { useRef } from "react";

import { DevState } from "#scripts/lib/dev/DevState.tsx";
import { MountDebugComponent } from "#scripts/lib/dev/MountDebugComponent.tsx";
import { useTodoVM } from "../TodoVMContext.tsx";
import { Queryable } from "./Queryable.tsx";

// #region todo-vm-ui-livestore
export const MainSection: React.FC = () => {
  const vm = useTodoVM();
  const sectionRef = useRef<HTMLElement>(null);

  return (
    <section ref={sectionRef} data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/MainSection.tsx:15:31" data-name="section" className="todos">
      {/* #hide debugs */}
      <MountDebugComponent
        id="!visibleTodos"
        debugKey="devstate"
        render={<DevState data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/MainSection.tsx:20:27" data-name="DevState" data={vm.itemList.items$} name="Todos" />}
      />
      {/* #endhide debugs */}
      <ul data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/MainSection.tsx:23:11" data-name="ul" className="todo-list">
        <Queryable query={vm.itemList.items$}>
          {(items) =>
            items.map((item) => (
              <li data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/MainSection.tsx:27:19" data-name="li" className="state" key={item.key}>
                <Queryable query={item.completed$}>
                  {(completed) => (
                    <input data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/MainSection.tsx:30:28" data-name="input" className="toggle" type="checkbox" checked={completed} onChange={() => item.toggleCompleted()} />
                  )}
                </Queryable>
                <label data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/MainSection.tsx:33:24" data-name="label">
                  <Queryable query={item.text$} />
                </label>
                <button type="button" data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/MainSection.tsx:36:39" data-name="button" className="destroy" onClick={() => item.remove()} />
              </li>
            ))
          }
        </Queryable>
      </ul>
    </section>
  );
};
// #endregion todo-vm-ui-livestore
